<template>

  <ion-page id="puzzle-offline-toggle-page">
     <ion-content >
       <div :class="{ 'text-dark' : isDark,'text-light' : !isDark }" 
             :style="styleOneFrame">
    
      <ion-item>
      <h2> {{ message }}</h2>
      </ion-item>
      <ion-item>
        {{ t("This will be reflected on the menu and in the puzzle programs") }}
    </ion-item>
    </div>
    </ion-content>
   </ion-page>
  </template>
  
  <script setup>
  
  import { IonItem,IonInput,IonPage, IonContent } from '@ionic/vue';
  
  import { ref, watch } from 'vue'
  import { doStartupCheck } from '@/composables/startupCheck.js'
  import { useConnectionStore } from '@/stores/connectionStore';
  import { useWindowSizeStore } from '@/stores/windowSizeStore';
  import { t } from '@/composables/translateText.js'

  import { availableWidthHeight } from '@/composables/screenSize'
  const connectionStore = useConnectionStore()
    
  const isDark = ref(connectionStore.getDarkmode != "" && connectionStore.getDarkmode != "light")
  const menuTrigger = ref(0)
  
  const styleOneFrame = ref({
     position : "absolute",
     "overflow-y" : "scroll",
     top : "0px",
     left : "100px",
     width: "100px",
     height : "100px"
   })
  
   const message = ref("")
   const workOfflinePuzzles = connectionStore.getWorkOfflinePuzzles
   if (workOfflinePuzzles == "yes")
    message.value = t("You'll now be shown puzzles from the downloaded offline collection")
   else
    message.value = t("You're back to accessing puzzles from the millions of online puzzles")
  
  const windowSizeStore = useWindowSizeStore()
  const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] })
  updateWidthHeights()
  
  doStartupCheck(false)
  
  watch(() => windowSizeStore.getWindowSize, () => {
      //console.log('*********** window size changes detected')
      windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] }
      //console.log("*** logoff new window size",windowSizeRef.value)
      menuTrigger.value++
      updateWidthHeights()
    })
    
  
  function updateWidthHeights() {
  
    const availableSpace = availableWidthHeight()
    const oneframePositionTop = availableSpace.topIndent
    const oneframePositionLeft = availableSpace.leftRightIndent + availableSpace.leftIndent
    const oneframeHeight = availableSpace.height - oneframePositionTop + availableSpace.topIndent
    const oneframeWidth = availableSpace.width - availableSpace.leftRightIndent * 2
  
    styleOneFrame.value.height = oneframeHeight + "px"
    styleOneFrame.value.width = oneframeWidth + "px"
    styleOneFrame.value.top = oneframePositionTop + "px"
    styleOneFrame.value.left = oneframePositionLeft + "px"
  }
  
  </script>
  
  <style scoped>
  
  .item{
    margin:10px auto;
  }
  
  </style>